<script lang="ts">
	import { format } from 'svelte-i18n';

	import PvSetupSettingsV2 from './PvSetupSettingsV2.svelte';
	import SettingsItemBoundary from '../shared/SettingsItemBoundary.svelte';

	import { clearSolarSetupFromHome } from './shared/solar-setup-persist';
</script>

<SettingsItemBoundary
	idPrefix="solar-setup"
	heading={$format('solar_setup_error_title', { default: 'Solar setup could not load' })}
	message={$format('solar_setup_error_message', {
		default:
			'The saved solar meters for this home could not be read. Try again, reset Solar setup, or contact Shelly support.',
	})}
	recoveryLabel={$format('button_reset_solar_setup', { default: 'Reset Solar setup' })}
	onRecovery={clearSolarSetupFromHome}
>
	<PvSetupSettingsV2 />
</SettingsItemBoundary>
